import { render, staticRenderFns } from "./SingleColumn.vue?vue&type=template&id=48f6c268&scoped=true&lang=pug"
import script from "./SingleColumn.vue?vue&type=script&lang=js"
export * from "./SingleColumn.vue?vue&type=script&lang=js"
import style0 from "./SingleColumn.vue?vue&type=style&index=0&id=48f6c268&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f6c268",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48f6c268')) {
      api.createRecord('48f6c268', component.options)
    } else {
      api.reload('48f6c268', component.options)
    }
    module.hot.accept("./SingleColumn.vue?vue&type=template&id=48f6c268&scoped=true&lang=pug", function () {
      api.rerender('48f6c268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/SingleColumn.vue"
export default component.exports